
import { store, update } from '@/api/asks'
import { index } from '@/api/ask_categories'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  @Prop() public model!: Record<string, any>

  categories = []

  rules = {
    question: [
      { required: true, message: '请输入问题', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    answer: [
      { required: true, message: '请输入回答', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    ask_category_id: [
      { required: true, message: '请选择所属分类', trigger: 'change' }
    ]
  }

  loading = false

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    const params: Record<string, any> = this.model
    try {
      if (params.id) {
        await update(params.id, params)
      } else {
        await store(params)
      }
      this.$eva.success('Submit the success!')
      this.$router.push({ name: 'asks' })
    } finally {
      this.loading = false
    }
  }

  onUploaded (url: string): void {
    this.model.images.push(url)
  }

  async created () {
    const { data } = await index({ collection: true })
    this.categories = data
  }
}
